import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../../store/auth-context";
import { Box, Button, Card, CardContent, Container, Grid, Typography } from '@mui/material';
// Service
import { get, post } from "../../../services/FetchHelper";
// Utils
import {
    InitialForgetPasswordState,
    ForgetPasswordSchema,
    ForgetPasswordFormFields,
} from "./ForgetPassword.utils";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import { StyledDrawerForm } from "../../../configs/GoStyles";
import Iconify from "../../../components/iconify/Iconify";
import EntityConstants from "../../../configs/EntityConstants";
import RouteConstants from "../../../configs/RouteConstants";

const ForgetPassword = () => {
    const navigate = useNavigate();
    const [formFields, setFormFields] = useState(ForgetPasswordFormFields);

    const handleSubmit = async (values) => {
        try {
            const response = await post(EntityConstants.FORGET_PASSWORD, {
                forget_password: values,
            });
            if ([200, 201].indexOf(response.status) > -1) {
                toast.success("Password change request submitted...");
                sessionStorage.clear();
                navigate("/");
            } else {
                const data = await response.json();
                toast.error(data.message);
            }
        } catch (error) {
            console.log(error)
            toast.error("Failed Request...");
        }
    };

    useEffect(() => {
        const getCompanies = async () => {
            try {
                const response = await get(EntityConstants.OPEN_COMPANIES, "max=all");
                const data = await response.json();
                setFormFields(prevFormFields =>
                    prevFormFields.map(field =>
                        field.name === "company_id" && field.type === "select"
                            ? { ...field, options: data }
                            : field
                    )
                );
            } catch (error) {
                toast.error("Failed to fetch companies.");
            }
        };
        getCompanies();
    }, []);

    return (
        <Container maxWidth="xs">
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                }}
            >
                <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                        <Typography variant="h5" component="h1" gutterBottom>
                            Forget Password
                        </Typography>
                        <Formik
                            enableReinitialize
                            initialValues={InitialForgetPasswordState}
                            validationSchema={ForgetPasswordSchema}
                            onSubmit={(values) => handleSubmit(values)}
                        >
                            {({
                                values,
                                touched,
                                errors,
                                dirty,
                                isSubmitting,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                            }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <StyledDrawerForm>
                                        <Grid
                                            container
                                            maxWidth="sm"
                                            rowSpacing={1}
                                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                                        >
                                            {formFields.map((formField, index) => {
                                                return (
                                                    <Grid key={index} item xs={12} sm={12} md={12} lg={12}>
                                                        <GoForm
                                                            config={formField}
                                                            values={values}
                                                            touched={touched}
                                                            errors={errors}
                                                            handleChange={handleChange}
                                                        />
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>
                                        <Box sx={{ textAlign: 'right', mt: 1 }}>
                                            <Link to="/" variant="body2">
                                                Login
                                            </Link>
                                        </Box>
                                        <Box sx={{ p: 2, textAlign: "center" }}>
                                            <Button
                                                size="large"
                                                variant="contained"
                                                type="submit"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? "Rquesting..." : "Submit"}
                                            </Button>
                                        </Box>
                                    </StyledDrawerForm>
                                </Form>
                            )}
                        </Formik>
                    </CardContent>
                </Card>
            </Box>
        </Container>
    );
};

export default ForgetPassword;